<template>
  <div class="order-notice schedule-change-notice">
    <div class="notice-hero">
      <div class="hero-icon hero-icon--warn">
        <i class="el-icon-time" />
      </div>
      <div class="hero-title">{{ payload.title || '船期信息变更通知' }}</div>
      <div class="hero-desc">操作人：{{ payload.operatorName || '—' }}</div>
    </div>

    <div class="info-card">
      <div class="info-item">
        <div class="info-label">订单号</div>
        <div class="info-value">{{ payload.orderNo || '—' }}</div>
      </div>
      <div class="info-item">
        <div class="info-label">航线</div>
        <div class="info-value">{{ payload.route || '—' }}</div>
      </div>
      <div class="info-item">
        <div class="info-label">船司</div>
        <div class="info-value">{{ payload.carrierCode || '—' }}</div>
      </div>
      <div class="info-item">
        <div class="info-label">船期</div>
        <div class="info-value">{{ payload.scheduleInfo || '—' }}</div>
      </div>
    </div>

    <!-- 变更明细：独立卡片，逐条结构化展示 -->
    <div v-if="changeList.length" class="change-section">
      <div class="change-section-title">变更内容</div>
      <div class="change-list">
        <div v-for="(item, idx) in changeList" :key="idx" class="change-row">
          <span class="change-field">{{ item.field }}</span>
          <span class="change-old">{{ item.oldVal }}</span>
          <span class="change-arrow">→</span>
          <span class="change-new">{{ item.newVal }}</span>
        </div>
      </div>
    </div>

    <div class="notice-actions">
      <el-button @click="$emit('read')">已读</el-button>
      <el-button type="primary" @click="$emit('view-order')">查看订单</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ScheduleChangeNotice',
  props: {
    payload: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    /**
     * 将 changeDetail 字符串拆分为结构化数组
     * 后端格式: "截关时间: 2026-08-01 → 2026-08-05；20GP系统卖价: 100 → 200"
     * 解析结果: [{ field: '截关时间', oldVal: '2026-08-01', newVal: '2026-08-05' }, ...]
     */
    changeList() {
      const detail = this.payload.changeDetail
      if (!detail) return []
      return detail.split('；').filter(s => s.trim()).map(item => {
        const match = item.match(/^(.+?):\s*(.+?)\s*→\s*(.+)$/)
        if (match) {
          return { field: match[1].trim(), oldVal: match[2].trim(), newVal: match[3].trim() }
        }
        return { field: item, oldVal: '', newVal: '' }
      })
    }
  }
}
</script>

<style scoped>
.order-notice {
  padding: 4px 4px 0;
}
.notice-hero {
  text-align: center;
  margin-bottom: 20px;
}
.hero-icon {
  width: 56px;
  height: 56px;
  margin: 0 auto 14px;
  border-radius: 14px;
  background: #e8f3ff;
  color: #3370ff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 26px;
}
.hero-icon--warn {
  background: #fff3e0;
  color: #f59e0b;
}
.hero-title {
  font-size: 18px;
  font-weight: 700;
  color: #1f2329;
  margin-bottom: 8px;
  line-height: 1.4;
}
.hero-desc {
  font-size: 13px;
  color: #8f959e;
  line-height: 1.6;
  padding: 0 8px;
}
.info-card {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px 20px;
  padding: 16px 18px;
  background: #f7f8fa;
  border: 1px solid #eef0f3;
  border-radius: 10px;
}
.info-item {
  min-width: 0;
}
.info-label {
  font-size: 12px;
  color: #8f959e;
  margin-bottom: 4px;
}
.info-value {
  font-size: 14px;
  font-weight: 600;
  color: #1f2329;
  word-break: break-all;
  line-height: 1.4;
}

/* 变更明细区域 */
.change-section {
  margin-top: 16px;
}
.change-section-title {
  font-size: 12px;
  color: #8f959e;
  font-weight: 500;
  margin-bottom: 8px;
}
.change-list {
  background: #fff8f0;
  border: 1px solid #ffe4c4;
  border-radius: 8px;
  padding: 12px 14px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.change-row {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  line-height: 1.5;
}
.change-field {
  color: #646a73;
  font-weight: 500;
  flex-shrink: 0;
}
.change-old {
  color: #b2b6bd;
  text-decoration: line-through;
}
.change-arrow {
  color: #8f959e;
  flex-shrink: 0;
}
.change-new {
  color: #f59e0b;
  font-weight: 600;
}

.notice-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 22px;
}
</style>
